export default {
  findSubKat : state => id => state.subKategoriList.find(v => v.id === id),
  filterSubKat : state => id => state.subKategoriList.filter(v => v.kategori !== null).filter(v => v.kategori.id === id)  
}
